import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=2fd327f6&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"
import style0 from "./Headline.vue?vue&type=style&index=0&id=2fd327f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd327f6",
  null
  
)

export default component.exports